<template>
  <div class="my-sites">
    <div class="mb-2">
      <b-alert show variant="warning" v-if="showHints()">
        <router-link to="/profile">{{
          $t("sites.click-to-enable")
        }}</router-link>
      </b-alert>
      <h3 style="display:inline-block">{{ $t("sites.my-sites") }}</h3>
      <b-button style="float: right" @click="$refs.editSiteRef.show()">{{
        $t("sites.add-site")
      }}</b-button>
    </div>
    <div class="overflow-auto" v-if="totalCount / size > 1">
      <b-pagination-nav
        :link-gen="generateLink"
        :number-of-pages="generateNumberOfPages()"
        v-model="page"
      ></b-pagination-nav>
    </div>
    <b-table-lite :fields="fields" :items="sites" hover responsive>
      <template v-slot:row-details="row">
        {{ row }}
      </template>
      <template v-slot:cell(domainName)="record">
        {{ record.item.domainName }}
        <div v-if="record.item.port !== 443">
          :{{ record.item.port || 443 }}
        </div>
        <div>
          {{ record.item.ip }}
        </div>
      </template>

      <template v-slot:cell(status)="record">
        <div>
          {{ $t("sites.status." + record.item.status) }}
        </div>
      </template>
      <template v-slot:cell(expiredIn)="record">
        <div v-b-tooltip.hover :title="$formatTime(record.item.expiredAt)">
          {{ $relativeTime(record.item.expiredAt) }}
        </div>
      </template>
      <template v-slot:cell(lastChecked)="record">
        <div :title="$formatTime(record.item.lastCheck)">
          {{ $time(record.item.lastCheck) }}
        </div>
      </template>

      <template v-slot:cell(operation)="record">
        <div>
          <b-icon-trash
            variant="danger"
            class="cursor-pointer"
            @click="deleteSite(record.item)"
          ></b-icon-trash>
          <site-check :site="record.item" @refresh="loadData" />
        </div>
      </template>
    </b-table-lite>

    <edit-site ref="editSiteRef" @refresh="loadData" />
  </div>
</template>

<script>
import EditSite from "@/components/EditSite.vue";
import PaginationMixin from "@/mixins/pagination";
import SiteCheck from "./SiteCheck";
import { mapState } from "vuex";

export default {
  components: { EditSite, SiteCheck },
  mixins: [PaginationMixin],
  data() {
    return {
      sites: [],
      fields: [
        {
          key: "domainName",
          label: this.$t("sites.domain-name"),
        },
        {
          key: "status",
          label: this.$t("sites.status2"),
        },
        {
          key: "expiredIn",
          label: this.$t("sites.expired-in"),
        },
        {
          key: "lastChecked",
          label: this.$t("sites.last-check"),
        },
        {
          key: "operation",
          label: this.$t("sites.operation"),
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      console.log(this.size);
      const params = {
        page: this.$route.query.page || 1,
        size: this.$route.query.size || this.size || 20,
      };
      this.page = params.page;
      this.size = params.size;
      this.$api.sites.getUserSites(params).then((res) => {
        const sites = res.data.data;
        sites.map((site) => {
          if (site.status === "failed") {
            site["_rowVariant"] = "warning";
          } else if (site.expiredAt && new Date(site.expiredAt) < new Date()) {
            site["_rowVariant"] = "danger";
            site.status = "expired";
          } else if (
            site.expiredAt &&
            new Date(site.expiredAt) - new Date() < 14 * 24 * 60 * 60 * 1000
          ) {
            site["_rowVariant"] = "warning";
            site.status = "expiredin14days";
          } else {
            site.status = "valid";
          }
        });

        this.sites = sites;
        this.totalCount = res.data.count;
      });
    },
    async deleteSite(site) {
      const result = await this.$bvModal.msgBoxConfirm(
        this.$t("sites.sure-to-delete", { site: site.domainName })
      );

      if (result) {
        await this.$api.sites.deleteSite(site.id);
        await this.loadData();
      }
    },
    showHints() {
      const profile = this.user.profile;
      return (
        profile && !profile.emailOn && !profile.serverChanOn && !profile.barkOn
      );
    },
  },
  computed: {
    ...mapState("user", ["user"]),
  },
};
</script>

<style lang="scss" scoped>
.my-sites {
  margin: 25px 0;
}
.table-sites {
  margin: 10px;
}
</style>
